import React from 'react';
import {ArrowMemoizedIcon} from './ArrowMemoizedIcon'; // import your memoized icon

const SuggestionItem = React.memo(function SuggestionItem({
  suggestion,
  index,
  expandedIndex,
  handleSuggestionClick,
  toggleReadMore,
}) {
  const isMasked = suggestion?.shouldApplyMask && !suggestion?.metadata && expandedIndex !== index;
  const isExpanded = expandedIndex === index;

  return (
    <div className="search-container-suggestions-list-suggestion-item">
      <div className="content">
        {suggestion?.sessionCode && (
          <div className="search-container-suggestions-list-suggestion-item-sessionCode">
            Session Code: {suggestion?.sessionCode}
          </div>
        )}

        <div
          className="search-container-suggestions-list-suggestion-item-name"
          onClick={() => handleSuggestionClick(suggestion)}
        >
          {suggestion.name || suggestion.sessionName}
        </div>

        {suggestion?.utcStartTime > 0 && (
          <div className="search-container-suggestions-list-suggestion-item-sessionCode">
            {suggestion?.formattedTime}
          </div>
        )}

        <div>
          <div
            className={`category ${isExpanded ? 'expanded' : ''} ${isMasked ? 'masked-content' : ''}`}
            onClick={() => handleSuggestionClick(suggestion)}
          >
            {suggestion.metadata
              ? suggestion.metadata
              : suggestion.description}
          </div>

          {isMasked && (
            <div
              className="search-container-suggestions-list-suggestion-item-read-more"
              onClick={() => toggleReadMore(index)}
            >
              {isExpanded ? 'Read Less ▲' : 'Read More ▼'}
            </div>
          )}
        </div>
      </div>

      <div
        className="search-container-suggestions-list-suggestion-item-arrow-button"
        onClick={() => handleSuggestionClick(suggestion)}
      >
        <ArrowMemoizedIcon />
      </div>
    </div>
  );
});

export default SuggestionItem;
